import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { isKenoType } from '../../../utils/LotteryHelpers';
import { getStakesSum } from '../helpers/pickHelper';
import { RootState } from '../redux/store';

import { convertAmount } from 'utils/formatters';

import { isTemplateZeta } from 'utils/template';

export default function WinUpTo() {
    const { t } = useTranslation();
    const { gameType, lottery, currencyCode, multiplier, stakes, stakeMin } = useSelector(
        (state: RootState) => state.playStore
    );
    const { numbersToPlay } = useSelector((state: RootState) => state.kenoPlayStore);
    const [winUpToAmount, setWinUpToAmount] = useState<number>(0);

    const getMaxPrize = () => {
        const prize = lottery.maxPrizes[isKenoType(lottery.type) ? numbersToPlay : gameType?.slug ?? 'default'];

        return prize > 0 ? prize : 0;
    };

    useEffect(() => {
        // we want to show amount even if no line is picked
        const stakesSum = getStakesSum(stakes) || 1;
        setWinUpToAmount(getMaxPrize() * multiplier * stakesSum);
    }, [multiplier, stakes, gameType, numbersToPlay]);

    if (winUpToAmount <= 0 || isTemplateZeta()) {
        return null;
    }

    return (
        <div className="card bg-primary border-primary win-up-to-card">
            <div className="card-body text-center text-white">
                <p className="mb-0">
                    {t('playPicker.youCanWinUpTo')}
                    <br />
                    <strong className="win-up-to-amount">{convertAmount(winUpToAmount, currencyCode)}</strong>
                </p>
            </div>
        </div>
    );
}
